import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom'
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';
import './SearchSymptoms/SearchSymptoms.css';

import { Form, Row, Col, Input, Button, Select, Typography, Radio, Alert, Popover, Tag, Tooltip } from 'antd';
import NoResult from './NoResult/NoResult';
import ResultFound from './ResultFound/ResultFound';
import ScreenHome from './ScreenHome/ScreenHome';
import { connect } from 'react-redux';
import HttpRequest from '../../../../utils/HttpRequest';
import { createVersion, getCaseAnalysisDetails, getCaseRequest, updateCaseRequest } from "../../CaseApiActions";
import SearchSymptomsComponent from './SearchSymptoms/SearchSymptoms'
import ButtonWithIcon from '../../../../utils/components/ButtonWithIcon/ButtonWithIcon'
import './CaseDashboard.css'
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon';
import { CloseOutlined, SearchOutlined, StopOutlined, UndoOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Title } = Typography;

function queryJSONToString(node) {
  if (!node) return '';

  // Base case: single term
  if (node.term) {
    return `"${node.term}"`;
  }

  // Recursive case: logical operator with children
  const { operator, children } = node;

  const parts = children.map(child => {
    const part = queryJSONToString(child);
    // Add parentheses around sub-groups
    return child.operator ? `(${part})` : part;
  });

  return parts.join(` ${operator} `);
}
const ethnicityOptions = [
  { id: 1, value: 'American Indian or Alaska Native', label: 'American Indian or Alaska Native' },
  { id: 2, value: 'Asian', label: 'Asian' },
  { id: 3, value: 'Black or African American', label: 'Black or African American' },
  { id: 4, value: 'Hispanic or Latino', label: 'Hispanic or Latino' },
  { id: 5, value: 'Middle Eastern or North Africa', label: 'Middle Eastern or North Africa' },
  { id: 6, value: 'Pacific Islander', label: 'Pacific Islander' },
  { id: 7, value: 'White', label: 'White' },
  { id: 8, value: 'Other', label: 'Other' },
  { id: 9, value: 'Unknown', label: 'Unknown' }
];

const CaseDashboardForm = (props) => {
  // const { getFieldDecorator } = props.form;
  const abortControllerRef = useRef(null);
  const location = useLocation();
  const history = useHistory()
  const urlQueryParams = new URLSearchParams(location.search);
  const [selections, setSelections] = useState([]); // Stores selections with logic
  const [ethnicity, setEthnicity] = useState([]);
  const [age, setAge] = useState(undefined);
  const [gender, setGender] = useState('male'); // male|female
  const [geneFilter, setGeneFilter] = useState(undefined)
  const [query, setQuery] = useState(undefined)
  const [queryJSON, setQueryJSON] = useState(null)
  const [clinicalFeatures, setClinicalFeatures] = useState(undefined)

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [fetchId, setFetchId] = useState(0); // counter to determine search call

  const [terms, setTerms] = useState([])
  // const [masterCase, setMasterCase] = useState(null)
  const [genes, setGenes] = useState(null)
  const [totalGenes, setTotalGenes] = useState(0)
  const [searchRecord, setSearchRecord] = useState(null)
  const [allFieldsFilled, setAllFieldsFilled] = useState(undefined)

  // Populate search record to resume search
  useEffect(() => {
    const searchRecordId = urlQueryParams.get('searchRecordId')
    if (!searchRecordId) return

    async function fetchData() {
      const res = await new HttpRequest(null, `/searchHistory/${searchRecordId}`, 'get').send()
      return res.data.data
    }

    // fetch search record
    fetchData().then((data) => {
      props.form.setFieldsValue(data);
      setQuery(data.query)
      setQueryJSON(data.queryJSON)

      if (data.ethnicity) {
        let tempEthnicity;

        if (data.ethnicity.includes('"')) {
          tempEthnicity = data.ethnicity
            .match(/"([^"]+)"/g)
            ?.map(str => str.replace(/"/g, '')) || [];
        }
        else {
          tempEthnicity = [data.ethnicity.trim()];
        }

        tempEthnicity = tempEthnicity
          .map(val => ethnicityOptions.find(opt => opt.value === val))
          .filter(Boolean);

        setEthnicity(tempEthnicity);
      }

      // single term
      if (data.queryJSON.term) {
        setSelections([
          { value: data.queryJSON.term, type: 'term' }
        ])
      } else {
        const result = [];
        data.queryJSON.children.forEach((item, index) => {
          result.push({ value: item.term, type: 'term' });
          if (index < data.queryJSON.children.length - 1) {
            result.push({ value: 'AND', type: 'logic' });
          }
        });
        setSelections(result)
      }
    })
  }, [])





  // useEffect(() => {
  //   // TODO: remove
  //   const fetchData = async () => {
  //     const masterCaseId = 'a0811660-e702-11ef-afe5-9f6ba648f821'
  //     const res = await new HttpRequest(null, `/cases/${masterCaseId}`, 'get', {}).send()
  //     const masterCaseObj = res.data.data
  //     setMasterCase(masterCaseObj)
  //   }
  //   fetchData()
  // }, [])

  // load genes data
  useEffect(() => {
    if (fetchId === 0) return

    // Cancel previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoading(true)
    setGenes(null)
    setSearchRecord(null)

    // Fetch data from master case for the time being
    const fetchData = async () => {
      try {

        let queryString = "?withDisorders=true"
        if (geneFilter === 'withDisorders') {
          queryString = "?withDisorders=true"
        } else if (geneFilter === 'dominant') {
          queryString = "?dominant=true"
        } else if (geneFilter === 'recessive') {
          queryString = "?recessive=true"
        } else if (geneFilter === 'x-linked') {
          queryString = "?x-linked=true"
        }

        if (clinicalFeatures)
          queryString += "&clinicalFeatureSearchStr=" + clinicalFeatures;

        queryString += "&hpoQueryStr=" + query;
        queryString += "&start=" + 0;
        queryString += "&rows=" + 100000;

        const res = await new HttpRequest(null, `/genes${queryString}`, 'get', {}, {}, {
          signal: controller.signal,
        }).send()
        const { data } = res.data
        const { docs, numFound } = data.response
        setTotalGenes(numFound)
        setGenes(docs)
        if (numFound > 0) {
          saveSearchRecord({
            ethnicity,
            gender,
            age,
            geneFilter,
            clinicalFeatures,
            query,
            queryJSON
          })
        }
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    };
    fetchData()
  }, [fetchId])

  // load HPO terms
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await new HttpRequest(null, `/genes/getCompleteHpoTermHierarchy`, 'get', {})
          .send()
        const { data } = res.data
        let terms = []
        updateSunburstDataFormat(data[0], terms)
        setTerms(terms)
      } catch (err) {
        setError(err)
      }
    };
    fetchData()
  }, [])

  // TODO: need to replace this logic
  useEffect(() => {
    if (Array.isArray(selections)) {
      let symptomsQueryJSON = {}
      if (selections.length === 1) {
        symptomsQueryJSON = { term: selections[0].value }
      } else {
        symptomsQueryJSON.operator = 'AND'
        symptomsQueryJSON.children = selections.filter((i) => i.type === 'term').map((i) => { return { term: i.value } })
      }
      const queryStr = queryJSONToString(symptomsQueryJSON)
      // const symptoms = selections.reduce((acc, obj) => acc += ' ' + obj.value, '');
      setQuery(queryStr)
      setQueryJSON(symptomsQueryJSON)
      // setSymptoms(queryStr)
    } else {
      setQuery(undefined)
      setQueryJSON(null)
    }
  }, [selections])

  const saveSearchRecord = async (data) => {
    try {
      let ethnicitiesRaw;
      if (ethnicity.length) {
        ethnicitiesRaw = ethnicity.map(each => each.value)
      }
      let ethnicityQuery = ethnicity.map(opt => `"${opt.value}"`).join(' OR ');
      const res = await new HttpRequest(null, `/searchHistory`, 'post', {
        ethnicity: ethnicityQuery,
        age: data.age,
        gender: data.gender,
        geneFilter: data.geneFilter,
        clinicalFeatures: data.clinicalFeatures,
        query: data.query,
        queryJSON: data.queryJSON
      }).send()
      const searchRecord = res.data.data
      setSearchRecord(searchRecord)
    } catch (err) {
    }
  }

  const handleSubmit = (values) => {
    if (!(ethnicity.length > 0 && values.gender && values.age && query)) {
      setAllFieldsFilled(false)
      return
    }
    setAllFieldsFilled(true)

    // e.preventDefault(); // Prevent default form submission
    // props.form.validateFields((err, values) => {
    // if (!err) {
    // console.log("Form Submitted Successfully:", values);
    // setGeneFilterCheckedValues(values.geneFilterCheckedValues)
    setGeneFilter(values.geneFilter)
    setClinicalFeatures(values.clinicalFeatures)
    // setEthnicity(values.ethnicity)
    setAge(values.age)
    setGender(values.gender)
    handleSearch()
    // } else {
    //   console.log("Validation Failed:", err);
    // }
    // });
  };

  const handleSearch = () => {
    setFetchId((prev) => prev + 1)
  };

  const stopSearch = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  const handleEthnicityChange = (value) => {
    const selectedOption = ethnicityOptions.find(each => each.value == value);
    if (!ethnicity.some(each => each.value == value) && selectedOption) {
      setEthnicity(prev => [...prev, selectedOption])
    }
  }

  const handleRemoveOption = (index) => {
    setEthnicity((prevVal) => {
      const newVal = [...prevVal];
      newVal.splice(index, 1); // just remove the tag at that index
      return newVal;
    });
  };

  const resetSearch = () => {
    props.form.resetFields(); // Reset all form fields
    setSelections([])
    setGeneFilter(undefined)
    setClinicalFeatures(undefined)
    setEthnicity([])
    setAge(undefined)
    setGender(undefined)
    setGenes(null)
    setAllFieldsFilled(undefined)
  };

  const updateSunburstDataFormat = (node, hpoTerms) => {
    let ids = node.value.match(/HP:[0-9]{7}/g);

    let name = node.value;
    let hpoId = 0;

    if (ids && ids.length > 0) {
      hpoId = ids[0];
      name = node.value.replace(hpoId + ':', '');
    }

    let returnNode = { name, hpoId };

    node.hpoHierarchy = node.hasOwnProperty('hpoHierarchy') ? node.hpoHierarchy + " -> " + name : name;

    if (node.hasOwnProperty("pivot")) {
      returnNode.children = [];
      for (let pivotIndex in node.pivot) {
        let pivot = node.pivot[pivotIndex];
        pivot.hpoHierarchy = node.hasOwnProperty('hpoHierarchy') ? node.hpoHierarchy : name;
        returnNode.children.push(updateSunburstDataFormat(pivot, hpoTerms));
      }
    } else {
      returnNode.size = node.count;
    }

    hpoTerms.push({ text: name, hierarchy: node.hpoHierarchy, id: name + node.field, name: name, hpoId: hpoId });

    return returnNode;
  }

  return (
    <Row gutter={[40, 16]} style={{ height: '100%' }}>
      {/* Left Column */}
      <Col xs={24} sm={24} md={12} lg={8} xl={8}>


        <div className="flex-vertical-gap-2">
          <Form form={props.form} onFinish={handleSubmit} layout="vertical" style={{ padding: '0px', backgroundColor: 'transparent' }}>
            <div className="gs-theme__container margin-bottom-4" style={{ padding: '24px' }}>
              <Title style={{ margin: 0, marginBottom: '8px' }} level={2}>Demographic Information</Title>
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item label="Ethnicity (select one or more)" >
                    <Select
                      placeholder="Select"
                      // value={ethnicity}
                      value={null}
                      onSelect={handleEthnicityChange}
                      allowClear
                    >
                      {ethnicityOptions.map((ethnicity) => {
                        return (
                          <Option key={ethnicity.id} value={ethnicity.value}>{ethnicity.label}</Option>
                        )
                      })
                      }
                    </Select>

                    {ethnicity.length > 0 &&
                      <div
                        id="ethnicity-tags-container"
                        style={{
                          marginTop: 12,
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 8,
                          maxWidth: '100%',
                        }}
                      >
                        {ethnicity.map((item, index) => (
                          <Tooltip title={item.label} key={item.id}>
                            <Tag
                              className='ethnicity-tags'
                              closable
                              onClose={(e) => {
                                e.preventDefault();
                                handleRemoveOption(index);
                              }}
                            >
                              <span className='tag-label'>
                                {item.label}
                              </span>
                            </Tag>
                          </Tooltip>
                        ))}
                      </div>
                    }
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} md={6} lg={6}>
                  <Form.Item label="Age" name="age">
                    <Input
                      placeholder="00"
                      type="number"
                      min={1}
                      max={120}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={6} md={6} lg={6}>
                  <Form.Item label="Sex" name="gender" initialValue={'male'}>
                    <Radio.Group>
                      <Radio.Button value="male">M</Radio.Button>
                      <Radio.Button value="female">F</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div className="gs-theme__container" style={{ padding: '24px' }}>
              <Title style={{ margin: 0, marginBottom: '8px' }} level={2}>Search Criteria</Title>
              {/* <Form onSubmit={handleSubmit} layout="vertical" style={{ backgroundColor: '#F3F3F1' }}> */}

              <Form.Item label="Symptoms">
                <SearchSymptomsComponent options={terms} selections={selections} setSelections={setSelections} />
              </Form.Item>

              <Form.Item label={<>
                Clinical Features&nbsp;
                <Popover
                  id='clinical-features-info-popover'
                  title={null}
                  placement="right"
                  content={
                    <>
                      <b>Examples for Clinical Feature Search:</b>
                      <ol>
                        <li>microcephaly</li>
                        <li>cardiom* (* is wildcard, and stands for any number of characters - but not zero)</li>
                        <li>talipes AND dandy</li>
                        <li>seizu* AND microcep*</li>
                        <li>(delay OR mental retard*) NOT (regression OR deaf OR deafn* OR blind OR blindn*)</li>
                        <li>(hearing OR deaf OR deafn*) AND (hepati* OR liver) AND cardiomy* AND (delay OR retard*)</li>
                        <li>((liver AND dysfunc*) OR (hepat* AND dysfunc*)) AND cardi* AND (delay OR mental retard*)</li>
                        <li>short stature AND (sensorineur* OR deaf OR deafn*) AND calcific*</li>
                      </ol>
                    </>
                  }
                >
                  <CustomIcon name="Info" />
                </Popover></>
              } name="clinicalFeatures">
                <Input placeholder="Enter clinical features" />
              </Form.Item>

              {/* <Form.Item><Radio className="padding-bottom-1" defaultChecked disabled>With Disorders</Radio></Form.Item> */}

              <Form.Item label={undefined} name="geneFilter" initialValue='withDisorders' rules={[
                { required: false, message: "Please select gene filter!" },
              ]}>
                <Radio.Group
                  className="margin-top-2"
                // onChange={(e) => setGeneFilter(e.target.value)}
                // value={geneFilter}
                >
                  <div className="flex-vertical-gap-2">
                    <Radio style={{ marginLeft: 0 }} value="withDisorders">All Disorders</Radio>
                    <Radio style={{ marginLeft: 16 }} value="dominant">Dominant</Radio>
                    <Radio style={{ marginLeft: 16 }} value="recessive">Recessive</Radio>
                    <Radio style={{ marginLeft: 16 }} value="x-linked">X-Linked</Radio>
                  </div>
                </Radio.Group>
              </Form.Item>

              <Form.Item>
                <Button className="margin-top-2" htmlType="submit" type="primary" disabled={loading} block>
                  {loading ? 'Searching...' : 'Search'}<CustomIcon name="Search" />
                </Button>
              </Form.Item>

              {!loading && (
                <Form.Item>
                  <Button className="margin-top-2" type="default" block onClick={resetSearch}>
                    Reset<CustomIcon name="Reset" />
                  </Button>
                </Form.Item>
              )}

              {loading && (
                <Form.Item>
                  <Button className="margin-top-2" type="default" block onClick={stopSearch}>
                    Stop Search<CustomIcon name="CloseX" />
                  </Button>
                </Form.Item>
              )}

              {allFieldsFilled !== undefined && !allFieldsFilled && (
                <Form.Item>
                  <Alert className="custom-alert-error" message={"All patient information must be entered to search."} type="error" showIcon icon={<CustomIcon name="ErrorAlert" color="#FFFFFF" />} />
                </Form.Item>
              )}

              {/* </Form> */}
            </div>

          </Form>
        </div>

      </Col>

      {/* Right Column */}
      <Col xs={24} sm={24} md={12} lg={16} xl={16} style={{ height: '100%' }}>
        {genes === null && <ScreenHome activeStep={loading ? 2 : 1} />}
        {Array.isArray(genes) && (
          genes.length > 0 ? <ResultFound total={totalGenes} genes={genes} searchRecord={searchRecord} /> : <NoResult handleReset={resetSearch} />
        )}
      </Col>
    </Row>
  );
};

const CaseDashboardComponent = (props) => {
  const [form] = Form.useForm();
  return <CaseDashboardForm form={form} {...props} />;
};

const mapStateToProps = (state) => {
  return {
    users: state.user.users,
    loggedInUser: state.auth.loggedInUser,
    showSideMenu: state.dashboard.showSideMenu
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    // updatePageTitle: (pageTitle, enablePageTitle) => {
    //   dispatch(setPageTitle(pageTitle, enablePageTitle));
    // },

    // updateSecondaryPageTitle: (pageTitle) => {
    //   dispatch(setPageSecondaryTitle(pageTitle));
    // },

    getCaseAnalysisDetails: (caseId, queryString) => {

      return dispatch(getCaseAnalysisDetails(caseId, queryString)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    getCaseDetails: (caseId) => {
      return dispatch(getCaseRequest(caseId)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    reAnalyseCase: (caseId) => {
      return dispatch(createVersion({ caseId })).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    saveCaseStudySnapshot: (caseId, data) => {
      return dispatch(updateCaseRequest(caseId, data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
  }
};

const CaseDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseDashboardComponent);

export default CaseDashboard;
